import $ from 'jquery';
import 'lightgallery';
import Swiper from 'swiper/bundle';
import 'accordionjs';
import 'jquery-parallax.js';
import hcSticky from 'hc-sticky';
import 'sharer.js';

$('.share-buttons-wrapper').hover(
    function () {
        $('.share-buttons-inner').addClass('active');
    },
    function () {
        $('.share-buttons-inner').removeClass('active');
    }
);

// import 'accordionjs/accordion.css';
import 'lightgallery/dist/css/lightgallery.css';

document.addEventListener('DOMContentLoaded', function () {
    new hcSticky('.nf-sticky', {
        top: 185,
    });
});

$('.nf-accordions').accordionjs({
    closeAble: true,
});

const thumbGallery = new Swiper('.gallery-nav', {
    slidesPerView: 3,
    centeredSlides: true,
    centeredSlidesBounds: true,
    freeMode: true,
    mousewheel: true,
    spaceBetween: 8,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
    breakpoints: {
        470: {
            slidesPerView: 4,
        },
        600: {
            slidesPerView: 6,
        },
        1101: {
            slidesPerView: 4,
            direction: 'vertical',
        },
        1601: {
            slidesPerView: 5,
            direction: 'vertical',
        },
    },
});

const bigGallery = new Swiper('.gallery-big', {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.gallery-next',
        prevEl: '.gallery-prev',
    },
    on: {
        init: function (obj) {
            thumbGallery.slideTo(obj.activeIndex);
        },
        slideChange: function (obj) {
            navIndex(obj.activeIndex);
            thumbGallery.slideTo(obj.activeIndex);
        },
    },
});

const navIndex = (i) => {
    $('.gallery-nav .gallery-preview').removeClass('active');
    $('.gallery-nav .swiper-slide')
        .eq(i)
        .find('.gallery-preview')
        .addClass('active');
};

$('.gallery-nav .gallery-preview').on('click', function () {
    const index = $(this).parent().index();
    bigGallery.slideTo(index);
});

const lightBox = $('.gallery-big').lightGallery({
    selector: '.gallery-item',
    download: false,
    counter: false,
});

lightBox.on('onAfterSlide.lg', function (event, index) {
    bigGallery.slideTo(index);
});

const onMouseWheel = function () {
    clearTimeout($.data(this, 'timer'));

    $('.swiper-wrapper').addClass('mousewheel');

    $.data(
        this,
        'timer',
        setTimeout(function () {
            $('.swiper-wrapper').removeClass('mousewheel');
        }, 250)
    );
};

window.addEventListener('mousewheel', onMouseWheel, false);
window.addEventListener('DOMMouseScroll', onMouseWheel, false);

const accordionCollapseIcon = () => {
    $('.nf-accordions li').each(function () {
        const item = $(this);
        setTimeout(function () {
            if (item.hasClass('acc_active')) {
                item.find('.accordion-icon').text('-');
            } else {
                item.find('.accordion-icon').text('+');
            }
        });
    });
};

accordionCollapseIcon();

$('.nf-accordion-head').on('click', function () {
    accordionCollapseIcon();
});
